import React from 'react';
import { Box, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { MemberAvatar } from '@components/MemberAvatar';
import { PodiumRank } from '../../interfaces';
import { PODIUM_ENTRY_SIZES, PODIUM_PANEL_MIN_HEIGHT, PODIUM_PANEL_PADDING, PODIUM_STYLES } from '../../constants';
import { formatRankingScore } from '../../helpers';
import { IPodiumEntry } from './interfaces';

export const PodiumEntry: React.FC<IPodiumEntry> = ({
  entry,
  size = 'default',
}): JSX.Element => {
  const rank = entry.rank as PodiumRank;
  const styles = PODIUM_STYLES[rank];
  const sizes = PODIUM_ENTRY_SIZES[size];
  const padding = PODIUM_PANEL_PADDING[size];

  return (
    <Box
      sx={{
        position: 'relative',
        flex: rank === 1 ? 1.15 : 1,
        minWidth: 0,
        minHeight: PODIUM_PANEL_MIN_HEIGHT[size][rank],
        pt: padding.pt,
        pb: padding.pb,
        px: 0.75,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRadius: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(8px)',
        border: styles.border ?? '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: sizes.rankBadge.top,
          width: sizes.rankBadge.size,
          height: sizes.rankBadge.size,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: styles.badgeColor,
          color: '#111',
          fontSize: sizes.rankBadge.fontSize,
          fontWeight: 700,
        }}
      >
        {rank}
      </Box>

      <MemberAvatar
        slug={entry.member.slug}
        name={entry.member.fullName}
        sx={{
          width: sizes.avatar,
          height: sizes.avatar,
          mb: 0.5,
          border: '2px solid rgba(255, 255, 255, 0.35)',
        }}
      />

      {rank === 1 && (
        <EmojiEventsIcon
          sx={{
            fontSize: sizes.trophyFontSize,
            color: styles.scoreColor,
            mb: 0.25,
          }}
        />
      )}

      <Typography
        sx={{
          color: '#fff',
          textAlign: 'center',
          fontSize: sizes.nameFontSize,
          fontWeight: 600,
          lineHeight: 1,
          mb: 0.5,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {entry.member.fullName}
      </Typography>

      <Typography
        sx={{
          color: styles.scoreColor,
          fontWeight: 700,
          fontSize: sizes.scoreFontSize[rank],
          lineHeight: 1,
        }}
      >
        {formatRankingScore(entry.rankingScore)}
      </Typography>
    </Box>
  );
};
